import styled from 'styled-components'

// export const MediaContainer = styled.div`
//   flex: 1;
//   min-height: ${({ $minHeight }) => $minHeight || '80px'};
//   margin: ${({ $margin }) => $margin || '18px 0'};

//   display: flex;
//   align-items: center;
//   justify-content: center;

//   position: relative;
// `
export const MediaContainer = styled.div`
  flex: 1 1 0;
  width: 100%;
  min-height: 0;

  margin: ${({ $margin }) => $margin || '18px 0'};

  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;
  overflow: visible;
`
// export const MediaContainer = styled.div`
//   flex: 1;
//   width: 100%;
//   margin: ${({ $margin }) => $margin || '18px 0'};

//   display: flex;
//   align-items: center;
//   justify-content: center;

//   overflow: visible;
// `
export const CohortImage = styled.img`
  display: block;

  width: ${({ $width }) => $width || '100%'};
  height: ${({ $height }) => $height || '100%'};

  max-width: none;
  max-height: 100%;

  object-fit: fill;

  margin: ${({ $margin }) => $margin || '0'};
`
// export const CohortImage = styled.img`
//   display: block;

//   width: ${({ $width }) => $width || '100%'};
//   height: ${({ $height }) => $height || '150px'};

//   object-fit: ${({ $fit }) => $fit || 'contain'};

//   margin: ${({ $margin }) => $margin || '0 auto'};

//   transform: ${({ $transform }) => $transform || 'none'};
// `

export const CohortIcon = styled.img`
  display: block;

  width: ${({ $width }) => $width || '36px'};
  height: ${({ $height }) => $height || '36px'};

  object-fit: contain;

  margin: ${({ $margin }) => $margin || '0 0 15px'};
`